'use client';

import React from 'react';
import { useCartWithCarriers } from '@/hooks/useCartWithCarriers';

interface CarrierProviderProps {
  children: React.ReactNode;
}

/**
 * Provider que inicializa los carriers para el cálculo del carrito
 * Este provider debe envolver la aplicación para asegurar que los carriers
 * estén disponibles globalmente
 */
export const CarrierProvider: React.FC<CarrierProviderProps> = ({ children }) => {
  // Este hook se encarga de sincronizar los carriers con el store
  useCartWithCarriers();

  return <>{children}</>;
};

export default CarrierProvider;
